export default function NotFound() {
  return (<div>
    Oops... Page Not found
  </div>)
}